(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("linked-list", [], factory);
	else if(typeof exports === 'object')
		exports["linked-list"] = factory();
	else
		root["linked-list"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 